import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CrossIcon } from "@aureskonnect/react-ui";
import { AvForm } from "availity-reactstrap-validation";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import {
    setCountryKeyValue,
    store as generalSettingStore,
    setMessage,
    setIsAssociatedLangues,
    setLocalShop,
    setSelectedRow,
    setIsArchived,
    setEditedDataLanguage,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsLoading,
} from "../store";
import { store } from "@components/VerticalLayout/store";

import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import {
    CustomCardHeader,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";
import { ConfirmationModificationModal } from "./ConfirmationModificationModal";
import { languages } from "@constants/index";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import AdvancedDisplayNameModal from "@pages/SettingGeneral/DisplayName/AdvancedDisplayNameModal";
import {
    apiRequest,
    AssociateLangues,
    checkIfLanguageExist,
    checkIfLanguageFranchiseExist,
    checkIfLanguageFranchiseExistAndArchived,
    createLanguageItem,
    defaultLanguageFormState,
    fetchCountry,
    getId,
    languagesOptions,
} from "../hooks";
import LanguageBody from "./LanguageBody";
import ErrorToast from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { ConfirmationAssociatedMessage } from "../ConfirmationAssociatedMessage";

import "@assets/swal.css";
import "@assets/theme.css";
import "../index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-languages-select/css/react-languages-select.css";
import { useSelector } from "react-redux";
import { useFetchGlobal } from "../../../../api/hooks";

type LanguageFormType = {
    dataState: any;
    setModalState: Function;
    modalState: any;
    tableState: any;
    setTableState: Function;
};

export function LanguageForm({
    dataState,
    setModalState,
    modalState,
    tableState,
    setTableState,
}: LanguageFormType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, shopID, oneShop, operatorID } = useSnapshot(
        store
    );
    const listOfCountry = useSelector((state: any) => state.global.pays);

    const {
        shopsLanguagesData,
        languagesData,
        languagesFranchise,
        archivedLanguageOfFranchise,
        countryKeyValue,
        isActionsClicked,
        isEdited,
        dataArchive,
        isAssociatedLangues,
    } = useSnapshot(generalSettingStore);
    const shopId = oneShop ? shopID : 0;
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    const [languageFormState, setLanguageFormState] = React.useState<any>({
        ...defaultLanguageFormState,
    });
    function setLanguage(data: any) {
        setTableState({ ...tableState, language: data });
    }
    async function addLanguage() {
        setIsLoading(true);
        toast.dismiss();
        let id: any = getId(languageFormState, t);
        let indexOfLanguage = languagesOptions(t).findIndex(
            (el: any) => el.label === languageFormState.langue
        );
        let allData: any = [];
        let objectData: any = {};

        let shops = oneShop ? [shopId, "0"] : ["0"];
        shops.forEach((shop: any) => {
            objectData[shop.toString()] = {
                ...createLanguageItem(
                    {
                        ...languageFormState,
                        url_image:
                            languageFormState.uploadedImage !== ""
                                ? languageFormState.uploadedImage
                                : `https://flagpedia.net/data/flags/h80/${countryKeyValue.toLowerCase()}.webp`,
                    },
                    id,
                    true,
                    false,
                    (shop !== "0" && languagesData.length === 0) ||
                        (shop === "0" && languagesFranchise.length === 0)
                        ? true
                        : false,
                    shop,
                    languages[indexOfLanguage].label
                ),
            };
        });

        let dataLanguage = {
            userId: userID,
            shopId: oneShop ? [shopId, 0] : [shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            adding: true,
            uuidUser: uuidUser,
            data: objectData,
            isMultiShop: true,
        };
        allData.push(dataLanguage);

        let error: any = [];
        for (let dataLanguage of allData) {
            try {
                const result: any = await apiRequest(
                    dataLanguage,
                    fetchGlobal,
                    undefined,
                    languageFormState.uploadedImage
                );
                if (result.error) {
                    error.push(true);
                    throw Error("error");
                }
            } catch (e) {
                setIsLoading(false);
                ErrorToast(`${t("There's an error")}`);
            }
        }
        if (!error.includes(true)) {
            setIsLoading(false);
            ShowSuccessToast(`${t("The language was successfully added")}`);
            setTableState({
                ...tableState,
                dataIsUpdated: true,
                localFilterActive: false,
            });
            setIsEdited(false);
            setCountryKeyValue("");
            setLanguageFormState((prev: any) => ({
                ...prev,
                langue: "",
                displayName: "",
                country: "",
                countryKey: "",
                uploadedImage: "",
                numberActive: (prev.numberActive || 0) + 1,
                advancedDisplayName: {
                    languages: {
                        fr: "",
                        en: "",
                        nl: "",
                        es: "",
                        pt: "",
                        it: "",
                    },
                },
                isValidateButtonDisabled: false,
            }));
        }
    }

    async function editLanguage() {
        let dataAssociate: any[] = [];
        const id = tableState.rowData.Id;
        let indexOfLanguage = languagesOptions(t).findIndex(
            (el: any) => el.label === languageFormState.langue
        );
        dataAssociate = !oneShop
            ? AssociateLangues(shopsLanguagesData, tableState.rowData)
            : [];

        if (dataAssociate.length > 0) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                associated: [
                    {
                        Id: id,
                        language: languages[indexOfLanguage].label,
                        display_name: prev.displayName,
                        country: prev.country,
                        abbreviation: prev.abbreviation,
                        urlImage:
                            prev.uploadedImage !== ""
                                ? prev.uploadedImage
                                : `https://flagpedia.net/data/flags/h80/${countryKeyValue.toLowerCase()}.webp`,
                        isArchived: tableState.rowData.isArchived,
                        isFavorite: tableState.rowData.isFavorite,
                        isActive:
                            Object.keys(dataState).length === 0
                                ? tableState.rowData.isActive
                                : tableState.rowData.Id === dataState.id
                                ? dataState.state
                                : tableState.rowData.isActive,
                        shopId,
                        advancedDisplayName: prev.advancedDisplayName,
                    },
                    ...dataAssociate,
                ],
                isOpened: true,
            }));
        } else {
            setIsLoading(true);
            toast.dismiss();

            let dataLanguage = {
                userId: userID,
                shopId: [shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [shopId.toString()]: {
                        ...createLanguageItem(
                            {
                                ...languageFormState,
                                url_image:
                                    languageFormState.uploadedImage !== ""
                                        ? languageFormState.uploadedImage
                                        : `https://flagpedia.net/data/flags/h80/${countryKeyValue.toLowerCase()}.webp`,
                            },
                            id,
                            Object.keys(dataState).length === 0
                                ? tableState.rowData.isActive
                                : tableState.rowData.Id === dataState.id
                                ? dataState.state
                                : tableState.rowData.isActive,
                            tableState.rowData.isArchived,
                            tableState.rowData.isFavorite,
                            shopId,
                            languages[indexOfLanguage].label
                        ),
                    },
                },
            };
            setEditedDataLanguage(dataLanguage);
            try {
                const result: any = await apiRequest(
                    dataLanguage,
                    fetchGlobal,
                    undefined,
                    languageFormState.uploadedImage
                );
                if (result.error) {
                    throw new Error("error");
                }
                setIsLoading(false);
                ShowSuccessToast(
                    `${t(
                        dataAssociate.length > 0
                            ? "The language of franchise was successfully changed"
                            : "The language was successfully edited"
                    )}`
                );
                setModalState({
                    ...modalState,
                    isAddLanguageClicked: !modalState.isAddLanguageClicked,
                });
                setIsEdited(false);
                setLanguageFormState((prev: any) => ({
                    ...prev,
                    isValidateButtonDisabled: false,
                }));
                setTableState({
                    ...tableState,
                    dataIsUpdated: !tableState.dataIsUpdated,
                });
            } catch (e) {
                setIsLoading(false);
                ErrorToast(`${t("There's an error")}`);
            }
        }
    }

    function handleValidateButtonOnClickEvent() {
        let urlImage =
            languageFormState.uploadedImage !== ""
                ? languageFormState.uploadedImage
                : `https://flagpedia.net/data/flags/h80/${countryKeyValue.toLowerCase()}.webp`;
        let isLanguageFranchiseExist = checkIfLanguageFranchiseExist(
            languagesFranchise,
            t,
            setLocalShop,
            languageFormState.langue,
            shopID,
            setSelectedRow,
            languageFormState.displayName,
            languageFormState.country,
            languageFormState.uploadedImage,
            countryKeyValue,
            tableState,
            shopId,
            languageFormState.abbreviation,
            languageFormState.advancedDisplayName
        );
        let isLanguageFranchiseExistAndArchived = checkIfLanguageFranchiseExistAndArchived(
            archivedLanguageOfFranchise,
            t,
            setLocalShop,
            languageFormState.langue,
            shopID,
            setSelectedRow
        );
        if (languageFormState.isLanguageExist) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                isValidateButtonDisabled: false,
            }));
        }
        if (languageFormState.langue === "") {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectLangue: true,
                isValidateButtonDisabled: false,
            }));
        }
        if (languageFormState.country === "") {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectCountry: true,
                isValidateButtonDisabled: false,
            }));
        }
        if (
            languageFormState.advancedDisplayName.languages[i18nextLng] === ""
        ) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectName: true,
                isValidateButtonDisabled: false,
            }));
        }

        if (languageFormState.uploadedImage === "" && countryKeyValue === "") {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectImage: true,
                isValidateButtonDisabled: false,
            }));
        } else if (
            oneShop &&
            isLanguageFranchiseExist &&
            languageFormState.langue !== "" &&
            languageFormState.country !== "" &&
            languageFormState.advancedDisplayName.languages[i18nextLng] !==
                "" &&
            languageFormState.isNotImg === false &&
            languageFormState.isLanguageExist === false &&
            tableState.rowData.Id === undefined
        ) {
            setMessage(
                t(
                    "The language already exists in the franchise. do you want to associate it with this shop?"
                )
            );
            setIsAssociatedLangues(true);
            setLanguageFormState((prev: any) => ({
                ...prev,
                isValidateButtonDisabled: false,
            }));
        } else if (
            oneShop &&
            isLanguageFranchiseExistAndArchived &&
            languageFormState.langue !== "" &&
            languageFormState.country !== "" &&
            languageFormState.advancedDisplayName.languages[i18nextLng] !==
                "" &&
            languageFormState.isNotImg === false &&
            languageFormState.isLanguageExist === false
        ) {
            setMessage(
                t(
                    "Attention! the language is already archived at the franchise level"
                )
            );
            setIsArchived(true);
            setIsAssociatedLangues(true);
            setLanguageFormState((prev: any) => ({
                ...prev,
                isValidateButtonDisabled: false,
            }));
        } else if (
            languageFormState.langue === tableState.rowData[t("Language")] &&
            languageFormState.advancedDisplayName ===
                tableState.rowData.advancedDisplayName &&
            (urlImage === tableState.rowData.url_image ||
                tableState.rowData.url_image.endsWith(
                    languageFormState.uploadedImage?.name
                )) &&
            countryKeyValue === tableState.rowData.country.code
        ) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                isValidateButtonDisabled: false,
                isModalOpened: true,
            }));
        } else if (
            languageFormState.langue !== "" &&
            languageFormState.country !== "" &&
            languageFormState.advancedDisplayName.languages[i18nextLng] !==
                "" &&
            languageFormState.isNotImg === false &&
            languageFormState.isLanguageExist === false
        ) {
            if (tableState.rowData.Id !== undefined) editLanguage();
            else addLanguage();
        }
    }

    function setIsAddLanguageClicked(value: boolean) {
        setModalState({
            ...modalState,
            isAddLanguageClicked: value,
        });
    }
    function setDataIsUpdated(data: any) {
        setTableState({ ...tableState, dataIsUpdated: data });
    }
    function setDataLanguage(data: any) {
        setTableState({ ...tableState, language: data });
    }
    function setIsModalOpened(data: any) {
        setLanguageFormState({ ...languageFormState, isModalOpened: data });
    }
    function setAdvancedDisplayName(data: any) {
        setLanguageFormState({
            ...languageFormState,
            advancedDisplayName: data,
        });
    }
    function setIsAdvancedDisplayNameModalOpen(data: any) {
        setLanguageFormState({
            ...languageFormState,
            isAdvancedDisplayNameModalOpen: data,
        });
    }

    useEffect(() => {
        if (tableState.rowData.Id !== undefined) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectCountry: false,
                selectLangue: false,
                selectName: false,
                isNotImg: false,
                selectImage: false,
                title: t(
                    tableState.isConsult
                        ? "View a language"
                        : "Modify a language"
                ),
                langue: tableState.rowData[t("Language")],
                abbreviation: tableState.rowData.abbreviation,
                displayName: tableState.rowData.display_name,
                country: {
                    ...tableState.rowData.country,
                    label: t(tableState.rowData.country.label),
                },
                uploadedImage: tableState.rowData.url_image.startsWith(
                    "https://flagpedia.net/data/flags/h80"
                )
                    ? ""
                    : tableState.rowData.url_image,
                countryKey: tableState.rowData.country.code,
                advancedDisplayName: tableState.rowData.advancedDisplayName,
                associated: AssociateLangues(
                    shopsLanguagesData,
                    tableState.rowData
                ),
            }));

            setCountryKeyValue(tableState.rowData.country.code);
        } else {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectCountry: false,
                selectLangue: false,
                selectName: false,
                isNotImg: false,
                selectImage: false,
                title: t("Add a language"),
                langue: "",
                displayName: "",
                country: "",
                countryKeyValue: "",
                countryKey: "",
                uploadedImage: "",
                advancedDisplayName: {
                    languages: {
                        fr: "",
                        en: "",
                        nl: "",
                        es: "",
                        pt: "",
                        it: "",
                    },
                },
                associated: AssociateLangues(shopsLanguagesData, tableState),
            }));
            setCountryKeyValue("");
        }
        setIsEdited(false);
        fetchCountry(
            listOfCountry,
            AssociateLangues,
            setLanguageFormState,
            tableState,
            t
        ); // eslint-disable-next-line
    }, [
        tableState.rowData,
        t,
        modalState.isAddNewLanguageButtonClicked,
        modalState.isAddLanguageClicked,
    ]);

    useEffect(() => {
        let isLanguageExist = checkIfLanguageExist(
            languagesData,
            dataArchive,
            t,
            setLocalShop,
            languageFormState.langue,
            shopID,
            setSelectedRow
        );
        if (
            isLanguageExist &&
            (tableState.rowData.Id === undefined ||
                (tableState.rowData.Id !== undefined &&
                    tableState.rowData[t("Language")] !==
                        languageFormState.langue))
        ) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                isLanguageExist: true,
            }));
        } else {
            setLanguageFormState((prev: any) => ({
                ...prev,
                isLanguageExist: false,
            }));
        }
        // eslint-disable-next-line
    }, [
        languageFormState.country,
        tableState.rowData,
        languageFormState.langue,
    ]);

    React.useEffect(() => {
        if (languageFormState.isNotImg) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                borderColor:
                    prev.selectImage || prev.isNotImg ? "red" : "#c3bfbe",
                selectImage: false,
            }));
        } else {
            setLanguageFormState((prev: any) => ({
                ...prev,
                borderColor:
                    prev.selectImage || prev.isNotImg ? "red" : "#c3bfbe",
            }));
        }
    }, [languageFormState.isNotImg, languageFormState.selectImage]);

    useEffect(() => {
        if (
            languageFormState.advancedDisplayName.languages[i18nextLng] !== ""
        ) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                selectName: false,
            }));
        }
        // eslint-disable-next-line
    }, [languageFormState.advancedDisplayName, i18nextLng]);

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3 lan_txt_FRtitleFormLanguage">
                        {languageFormState.title}
                    </h5>
                    <CrossIcon
                        className="lan_icn_FRcloseForm"
                        height={13}
                        width={13}
                        onClick={() => {
                            setTableState({
                                ...tableState,
                                isConsult: false,
                            });
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setCountryKeyValue("");
                                    setModalState({
                                        ...modalState,
                                        isAddLanguageClicked: !modalState.isAddLanguageClicked,
                                    });
                                });
                            } else {
                                setCountryKeyValue("");
                                setModalState({
                                    ...modalState,
                                    isAddLanguageClicked: !modalState.isAddLanguageClicked,
                                });
                                setIsEdited(false);
                            }
                        }}
                    />
                </CustomCardHeader>
                <LanguageBody
                    tableState={tableState}
                    languageFormState={languageFormState}
                    setLanguageFormState={setLanguageFormState}
                />
                <CustomCardFooter className="pt-1 pb-2">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="lan_btn_FRcancel mr-2 cmn_btn_cancel"
                        variant="light"
                        onClick={() => {
                            if (isEdited === true) {
                                setActions(() => {
                                    setIsEdited(false);
                                    setModalState({
                                        ...modalState,
                                        isAddLanguageClicked: !modalState.isAddLanguageClicked,
                                    });
                                    setCountryKeyValue("");
                                });
                                setIsActionsClicked(!isActionsClicked);
                            } else {
                                setModalState({
                                    ...modalState,
                                    isAddLanguageClicked: !modalState.isAddLanguageClicked,
                                });
                                setCountryKeyValue("");
                            }
                            setTableState({
                                ...tableState,
                                isConsult: false,
                            });
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        disabled={languageFormState.isValidateButtonDisabled}
                        onClick={() => {
                            setLanguageFormState((prev: any) => ({
                                ...prev,
                                isValidateButtonDisabled: true,
                            }));
                            handleValidateButtonOnClickEvent();
                        }}
                        className={`lan_btn_FRvalidate cmn_btn_validate ${classnames(
                            {
                                "not-allowed-input-vr__clz":
                                    tableState.isConsult,
                            }
                        )}`}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            {languageFormState.isOpened ? (
                <ConfirmationModificationModal
                    languageFormState={languageFormState}
                    setLanguageFormState={setLanguageFormState}
                    modalState={modalState}
                    setModalState={setModalState}
                />
            ) : null}
            <ConfirmationEditMessage
                isModalOpened={languageFormState.isModalOpened}
                setIsModalOpened={setIsModalOpened}
                setIsAddClicked={setIsAddLanguageClicked}
                setEditedData={setDataLanguage}
            />
            {languageFormState.isAdvancedDisplayNameModalOpen && (
                <AdvancedDisplayNameModal
                    isConsult={tableState.isConsult}
                    isAdvancedDisplayNameModalOpen={
                        languageFormState.isAdvancedDisplayNameModalOpen
                    }
                    setIsAdvancedDisplayNameModalOpen={
                        setIsAdvancedDisplayNameModalOpen
                    }
                    setAdvancedDisplayName={setAdvancedDisplayName}
                    displayName={languageFormState.advancedDisplayName}
                    language={languagesData}
                    isActionsClicked={isActionsClicked}
                    setActions={setActions}
                    setIsActionsClicked={setIsActionsClicked}
                    setIsEdited={setIsEdited}
                />
            )}
            {isAssociatedLangues && oneShop && (
                <ConfirmationAssociatedMessage
                    setRowData={setLanguage}
                    setDataIsUpdated={setDataIsUpdated}
                    isModalOpened={isAssociatedLangues}
                    setIsModalOpened={setIsAssociatedLangues}
                    uploadedImage={languageFormState.uploadedImage}
                    setLanguageFormState={setLanguageFormState}
                />
            )}
        </React.Fragment>
    );
}
